// stl.js — bugfix de estabilidad (delegación + observer + editor)
// - Soporta hotspots y bloques/productos agregados en caliente
// - Evita doble binding (flag global)
// - Cierra al click fuera y con Escape
(function(){
  if (window.__STL_BOUND__) return;
  window.__STL_BOUND__ = true;

  function prime(scope){
    (scope || document).querySelectorAll('.stl__popover').forEach(p => {
      if(!p.hasAttribute('hidden')) p.setAttribute('hidden','');
    });
  }

  function closeAllIn(container){
    (container || document).querySelectorAll('.stl__popover').forEach(p => p.setAttribute('hidden',''));
  }

  function containerOf(node){
    return node ? node.closest('.stl') : null;
  }

  // Delegación de clicks
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.stl__dot');
    if (dot) {
      const wrap = dot.closest('.stl__dot-wrap');
      const pop = wrap ? wrap.querySelector('.stl__popover') : null;
      const container = containerOf(dot) || document;
      if (pop) {
        const isHidden = pop.hasAttribute('hidden');
        closeAllIn(container);
        if (isHidden) pop.removeAttribute('hidden');
      }
      e.stopPropagation();
      return;
    }

    // Cerrar si clic fuera de popover y fuera de dots
    if (!e.target.closest('.stl__popover') && !e.target.closest('.stl__dot')) {
      closeAllIn(document);
    }
  });

  // Escape para cerrar
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllIn(document);
  });

  // Observer: cuando se agreguen nodos (secciones/bloques) asegurar estado inicial
  const mo = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches('.stl__popover')) {
          prime(node.parentElement);
        } else if (node.querySelectorAll) {
          const pops = node.querySelectorAll('.stl__popover');
          if (pops.length) prime(node);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Eventos del editor de Shopify
  document.addEventListener('shopify:section:load', e => prime(e.target));
  document.addEventListener('shopify:block:select', e => prime(e.target));
  document.addEventListener('shopify:block:deselect', e => prime(e.target));

  // Primer priming
  prime(document);
})();
